export class UrlService {

    // ---------------------- Servicios Propios del API-GATEWAY---------------
    public static PRUEBA_API_GATEWAY = 'health';
    public static PERFIL = 'seus/perfil';
    public static LOGOUT = 'seus/logout';

    // ------------------Servicios MS-AYV-COTIZADOR-------------------------
    public static MENU = 'ms-ayv-cotizador/menu';
    public static MENU_DELEGADO = 'ms-ayv-cotizador/menu-delegado';
    public static URL_LOGIN = 'seus/login';

    //public static INFORMACION_BASICA_AGENTE = 'ms-ayv-cotizador/perfil';
    public static INFORMACION_BASICA_AGENTE = 'seus/user';
    public static ASESOR_PROTECCION = 'ms-ayv-cotizador/isProteccion';

    // ------------------Servicios MS-HOME- ARQUITECTURA 2.0-------------------------
    public static URL_HOME_MENU = 'home/menu';
    public static URL_HOME_DELEGADO = 'home/menu-delegado';
    public static URL_HOME_PROTECCION = 'home/isProteccion';

    // ------------------SERVICIOS COTIZADOR-PROSPECTOS-----------------------
    public static TIPO_DOCUMENTOS = 'prospectos-vida/tiposDocumento';
    public static CIUDADES = 'prospectos-vida/ciudades';
    public static OCUPACIONES = 'prospectos-vida/ocupaciones';
    public static GUARDAR_CLIENTE_PROSPECTO = 'prospectos-vida/prospectos';


    // ------------------SERVICIOS RED COMERCIAL-----------------------
    public static INFORMACION_COMPLEMENTARIA_AGENTE = 'redcomercial/asesores/';
    public static CIUDADES_ASESOR = 'redcomercial/ciudades';
    public static DELEGACIONES_USUARIO = 'redcomercial/delegacionUsuario';
    public static VALIDAR_IDEONEIDA = 'redcomercial/command/validarCertificacionProductos';



    // -----------------SERVICIOS CLIENTES----------------------------------------
    public static GUARDAR_CLIENTE = 'ms-clientes/cliente/guardarCliente';
    public static CONSULTAR_CLIENTE = 'ms-clientes/command/consultarCliente';

    // -----------------SERVICIOS REGULACION----------------------------------------
    public static VALIDAR_RIESGO_CONSULTABLE = 'regulacion/secureCommand/validarriesgosconsultables';
}



// WEBPACK FOOTER //
// ./src/app/contants/url-service.constant.ts